export default __webpack_public_path__ + "static/3-17b2b5bd4e8ed75de0f42452f3de43bd.jpg";